function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M117.787 139.496V32.66a7.507 7.507 0 00-7.504-7.503h-98.02A7.506 7.506 0 004.76 32.66v106.836A7.506 7.506 0 0012.263 147h98.02a7.506 7.506 0 007.504-7.504z",
  fill: "url(#paint0_linear)"
}), React.createElement("path", {
  d: "M80.013 147h-67.75a7.503 7.503 0 01-7.503-7.504V23.593a7.504 7.504 0 017.503-7.504h98.02a7.503 7.503 0 017.504 7.504v87.598c0 1.148-.452 2.25-1.258 3.068l-29.271 29.709A10.17 10.17 0 0180.013 147z",
  fill: "url(#paint1_linear)"
}), React.createElement("path", {
  d: "M61.273 147H11.491c-3.718 0-6.731-3.359-6.731-7.504V23.593c0-4.145 3.014-7.504 6.731-7.504h49.782V147z",
  fill: "url(#paint2_linear)"
}), React.createElement("path", {
  d: "M117.785 81.637v58.538c0 3.769-3.36 6.825-7.504 6.825h-98.02c-4.144 0-7.503-3.056-7.503-6.825V81.637c0-.415 113.027 0 113.027 0z",
  fill: "url(#paint3_linear)"
}), React.createElement("path", {
  d: "M117.403 112.983s-.222.628-1.095 1.5c-.324.325-28.879 29.31-28.879 29.31a10.755 10.755 0 01-7.66 3.207 4.502 4.502 0 004.502-4.502v-22.012a7.503 7.503 0 017.503-7.503h25.63z",
  fill: "url(#paint4_linear)"
}), React.createElement("path", {
  d: "M98.585 81.723H23.96v5.109h74.624v-5.11zm0 19.509H23.96v5.109h74.624v-5.109zm-29.611 19.509H23.961v5.11h45.013v-5.11zm29.611-78.045H23.96v5.11h74.624v-5.11zm0 19.512H23.96v5.11h74.624v-5.11z",
  fill: "#777"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M144.989 32.5c0-17.95-14.548-32.5-32.494-32.5C94.548 0 80 14.55 80 32.5S94.549 65 112.495 65c17.946 0 32.494-14.55 32.494-32.5z",
  fill: "#F36986"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M132.54 6.92a32.36 32.36 0 016.918 20.048c0 17.95-14.548 32.5-32.494 32.5a32.353 32.353 0 01-20.046-6.92C92.867 60.13 102.112 65 112.495 65c17.946 0 32.494-14.55 32.494-32.5 0-10.384-4.869-19.631-12.449-25.58z",
  fill: "#FC476E"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.558 37.959h-4.127a1.48 1.48 0 01-1.48-1.48V17.79c0-.817.663-1.48 1.48-1.48h4.127c.817 0 1.48.663 1.48 1.48v18.69a1.48 1.48 0 01-1.48 1.48z",
  fill: "#FFD2E3"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.559 16.311h-2.674c.817 0 1.48.663 1.48 1.48V36.48a1.48 1.48 0 01-1.48 1.48h2.674a1.48 1.48 0 001.48-1.48V17.79a1.48 1.48 0 00-1.48-1.48z",
  fill: "#FFBBD7"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M112.494 49.74a3.544 3.544 0 113.544-3.545v.002a3.544 3.544 0 01-3.544 3.544z",
  fill: "#FFD2E3"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M112.494 42.652c-.285 0-.562.035-.828.099a3.545 3.545 0 010 6.891 3.544 3.544 0 10.828-6.99z",
  fill: "#FFBBD7"
});

var _ref9 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 95.481,
  y1: 120.289,
  x2: 117.364,
  y2: 142.171,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#3B4041"
}), React.createElement("stop", {
  offset: 0.373,
  stopColor: "#6F7273"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#C3C3C3"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 61.272,
  y1: 59.223,
  x2: 61.272,
  y2: 228.51,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F2F2F2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#C3C3C3"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 31.231,
  y1: 84.808,
  x2: 90.808,
  y2: 36.99,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#C3C3C3",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#777"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 89.051,
  y1: 128.552,
  x2: -16.229,
  y2: 68.863,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#C3C3C3",
  stopOpacity: 0
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#777"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 93.877,
  y1: 125.285,
  x2: 102.836,
  y2: 134.245,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F2F2F2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#C3C3C3"
})), React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 11)",
  d: "M0 0h136v136H0z"
})));

var SvgRejectIcon = function SvgRejectIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 145,
    height: 147,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRejectIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reject-icon.bafdb170.svg";
export { ForwardRef as ReactComponent };